<template>
  <div id="recs">
    <v-row>
      <h1 class="mt-12 mb-12 ml-12 font-weight-light">
        Your Cart Items
      </h1>
      <v-col class="text-right">
        <v-btn
          v-if="this.$store.getters.cartItems.length > 0"
          outlined
          class="pl-4 pr-6 mt-12 mr-12  mb-12"
          x-large
          aria-label="Remove entire cart button"
          @click="removeEntireCart()"
        >
          <img
            class="pl-3 pr-3"
            src="@/assets/icons/remove_shopping_cart_orange.svg"
            alt="Remove from Shopping Cart icon"
          />
          Empty your entire cart</v-btn
        >
      </v-col>
    </v-row>
    <div v-if="this.$store.getters.cartItems.length > 0">
      <v-card
        v-for="r in this.$store.getters.cartItems"
        :key="r.id"
        class="mx-auto my-12"
      >
        <v-container>
          <v-row>
            <v-col>
              <v-img
                height="250"
                contain
                :src="r.fields.IMAGE"
                :alt="r.fields.TITLE"
              ></v-img>
            </v-col>
            <v-col>
              <v-card-title class="font-weight-black">{{
                r.fields.TITLE
              }}</v-card-title>

              <v-card-text>
                <v-row align="center" class="mx-0">
                  <v-rating
                    aria-label="Rate out of 5 stars"
                    :value="parseFloat(r.fields.RATING)"
                    half-increments
                    readonly
                  >
                    <template v-slot:item="props">
                      <v-icon aria-label="star" color="amber" size="20">{{
                        props.isFilled ? "mdi-star" : "mdi-star-outline"
                      }}</v-icon>
                    </template>
                  </v-rating>

                  <div class="black--text ml-4">
                    {{ r.fields.RATING }} ({{ r.fields.REVIEWS }})
                  </div>
                </v-row>

                <div class="my-4 subtitle-1 black--text">
                  {{ r.fields.PRICE }}

                  <v-chip class="ml-4">{{ r.fields.TYPE }}</v-chip>
                </div>

                <div>
                  {{ r.fields.DESCRIPTION }}
                </div>
              </v-card-text>

              <iframe
                class="mt-12 mb-12"
                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                :src="r.fields.VIDEOSRC"
                frameborder="0"
              ></iframe>

              <v-card-actions>
                <v-row>
                  <v-col>
                    <v-btn
                      aria-label="Remove from cart button"
                      class="pl-4 pr-6"
                      x-large
                      color="amber darken-1"
                      @click="removeFromCart(r)"
                    >
                      <img
                        class="pl-3 pr-3"
                        src="@/assets/icons/remove_shopping_cart.svg"
                        alt="Remove from shopping cart icon"
                      />
                      Remove</v-btn
                    >
                  </v-col>
                  <v-col>
                    <router-link
                      :to="{ name: 'Details', query: { record: r.id } }"
                      @click="this.$ga.event({
  eventCategory: 'cart',
  eventAction: 'route-to-details-page',
  eventLabel: 'see-more-details-button'
})"
                    >
                      <v-btn
                        class="pl-4 pr-6 mr-6"
                        x-large
                        color="amber darken-1"
                        aria-label="See more details button"
                      >
                        <v-icon class="pr-3">
                          mdi-note-text
                        </v-icon>
                        See More Details
                      </v-btn>
                    </router-link>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="pl-12 pr-12"
                      x-large
                      color="primary"
                      aria-label="Enroll button"
                      @click="enroll(r.fields.URL, r.fields.RECORD_ID)"
                    >
                      <v-icon class="pr-3"
                        >mdi-checkbox-marked-circle-outline</v-icon
                      > 
                      <!-- {{ record.fields.RECORD_ID }} -->
                      Enroll</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>
    <div v-else>
      <h2 class="text-center">
        Your cart is currently empty.
        <br />
        Add items to your cart by pressing these buttons on the site, as seen in
        the examples below.
      </h2>
      <v-row style="width: 100%;">
        <v-col class="xs6 sm6 md6 lg 6 xl6 text-right">
          <img
            class="cart-img"
            src="@/assets/cart-instruction.jpg"
            alt="cart instruction image 1"
          />
        </v-col>
        <v-col class="xs6 sm6 md6 lg 6 xl6">
          <img
            class="cart-img"
            src="@/assets/cart-instruction-2.jpg"
            alt="cart instruction image 2"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cart",
  data: () => ({
    loading: false,
    selection: 1,
  }),
  methods: {
    enroll(url, record_id) {
      this.$ga.event({
        eventCategory: 'cart',
        eventAction: 'enrollment',
        eventLabel: '',
        eventValue: record_id
      })
      window.open(`${url}`, '_blank','noopener');
    },
    removeFromCart(t) {
      this.$store.dispatch("removeCartItem", t);
      // success: green, info: blue, warning: orange, error: red
      this.$store.dispatch("setSnackbar", {
        color: "warning",
        text: "Removed this item to your cart.",
      });
    },
    removeEntireCart() {
      this.$store.dispatch("removeEntireCart");
      // success: green, info: blue, warning: orange, error: red
      this.$store.dispatch("setSnackbar", {
        color: "warning",
        text: "Removed all items from your cart.",
      });
    },
  },
};
</script>

<style scoped>
.cart-img {
  width: 100%;
}
</style>
